// Dashboards Tour
// Building and reading dashboards, widgets and KPI tracking
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id (#sb_dashboard); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const dashboardsTour = {
  id: 'dashboards',
  name: 'Dashboards Tour',
  displayName: 'See Your Business At A Glance',
  description: 'Building and reading dashboards, widgets and KPI tracking',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '#sb_dashboard',
      popover: {
        title: "📊 Welcome to Dashboards",
        description: `
          This is the first screen you should look at each morning: pipeline, revenue, conversations, and appointments in one view.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧱 Widgets Are the Building Blocks",
        description: `
          A dashboard is a grid of **widgets** — each one a number, chart, or list. Add the ones that matter, drag them where you want them.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎯 Pick Your Metrics",
        description: `
          Start with the handful that drive decisions: **new leads**, **opportunity value**, **appointments booked**, **revenue collected**. Vanity metrics just add noise.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📅 Date Ranges & Comparison",
        description: `
          Every dashboard respects a **date range** — and comparing to the previous period is what turns a number into a trend.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🗂️ Multiple Dashboards",
        description: `
          Build more than one: a **sales** view, a **marketing** view, a **client-facing** view. Each audience sees only what it needs.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔍 Drill Into the Detail",
        description: `
          Numbers raise questions. Click through from a widget into the underlying records to see exactly which deals or contacts are behind it.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 You Have a Command Center",
        description: `
          You can now:

✅ Build dashboards from widgets
✅ Track the metrics that drive decisions
✅ Compare periods to spot trends
✅ Drill from a number into the records

**Next:** build one dashboard with four widgets and check it daily for a week.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
